/**
 * @file Homepage Curtain.
 */

import { gsap } from 'gsap';

/**
 * Homepage Curtain component.
 */
const vHpCurtain = () => {
	const hpCurtain = document.querySelector('.v-hp-curtain');

	if (!hpCurtain) {
		return;
	}

	document.addEventListener('vOverlayOpening', ({detail}) => {
		if (detail.name !== 'nav') {
			return;
		}

		gsap.to(hpCurtain, {
			duration: 0.75,
			opacity: 1,
			onStart: () => {
				hpCurtain.classList.remove('hide');
			},
			onComplete: () => {
				gsap.set(hpCurtain, { clearProps: 'all' });
			},
		});
	});

	document.addEventListener('vOverlayTransitioned', ({detail}) => {
		if (detail.name !== 'nav') {
			return;
		}

		gsap.to(hpCurtain, {
			duration: 0.25,
			opacity: 0,
			onComplete: () => {
				hpCurtain.classList.add('hide');
				gsap.set(hpCurtain, { clearProps: 'all' });
			},
		});
	});
};

export default vHpCurtain;
